import React, { Component } from 'react'

import Cache from "../../frame/Cache";
import Config from "../../config/Config";
import WidgetTips from "../../widget/WidgetTips";
import WidgetPage from "../../widget/WidgetPage";
import WidgetAjax from "../../widget/WidgetAjax";
import WidgetMessage from '../../widget/WidgetMessage';
import LoadingTag from "../../img/frame/loading.gif";

class BusinessCatlogs extends Component {

    constructor(props)
    {
        super(props)
        this.state = {
            basePath:Config.getBasePath(),
            catlogData:[],
            messageOptions:{},
            catlogs:props.catlogs,
            isLoading:true,
            records:10,
            pageIndex:1
        }

        this.attention = this.attention.bind(this)
        this.messageRef = this.messageRef.bind(this);
        this.pageTurning = this.pageTurning.bind(this);
        this.loadCatalog = this.loadCatalog.bind(this);
        this.onLoadCatalog = this.onLoadCatalog.bind(this);
        this.loadCatalogFocus = this.loadCatalogFocus.bind(this);
        this.businessCatalogEntity = this.businessCatalogEntity.bind(this);
    }

    componentDidMount()
    {
        this.loadCatalog(this.props.catlogs.THMCODE)
    }

    /**
     * 请求商机目录
     */
    loadCatalog( THMCODE )
    {
        let { basePath, records, pageIndex } = this.state;

        let params = {
            "type" : 1,
            "page" : pageIndex,
            "records" : records,
            "THMCODE":THMCODE
        };

        WidgetAjax.ajax({url: basePath + "/business/catalog", params: params , callback: this.onLoadCatalog});
    }

    onLoadCatalog( result, backParam )
    {
        // console.log(result)
        if( result.status===0 ) 
        {
            let { results } = result
            this.setState({
                catlogData:[...results],
                isLoading:false
            },()=>{this.props.loadingOver(true)})
        }
        else if( result.status===10 )
        {
            Cache.logout(this.props);
        }
    }

    /**
     * 取消收藏
     * @param {*} data 
     */
    removeFavor( FOCUS, CTGCODE, NAME )
    {
        let { messageOptions } = this.state;

        messageOptions["isMessage"] = false ;
        messageOptions['FOCUS'] = FOCUS;
        messageOptions['CTGCODE'] = CTGCODE;
        messageOptions['NAME'] = NAME;

        if( FOCUS )
        {
            messageOptions["message"] = `确定要添加 ${NAME} 为关注吗？` ;
            messageOptions["title"] = "添加关注" ;
        }
        else
        {
            messageOptions["message"] = `确定要取消${NAME}的关注吗？` ;
            messageOptions["title"] = "取消关注" ;
        }

        messageOptions['confirmFunction'] = this.loadCatalogFocus;

        this.state['messageOptions'] = messageOptions;

        this.messageRef.open();
    }

    loadCatalogFocus()
    {
        let { basePath, messageOptions } = this.state;

        let params = {
            FOCUS : messageOptions['FOCUS'],
            CTGCODE: messageOptions['CTGCODE']
        };

        WidgetAjax.ajax({url: basePath + "/business/catalog_focus", params: params , callback:this.attention });
    }

    attention(result, params)
    {
        if( result.status === 0 )
        {
            let messageOptions = this.state.messageOptions;
            messageOptions["isMessage"] = true ;
            messageOptions["message"] = "操作成功！";
            messageOptions["title"] = "关注" ;
            this.state['messageOptions'] = messageOptions;

            this.setState({isLoading:true},()=>{
                this.loadCatalog(this.props.catlogs.THMCODE);
            
                this.messageRef.open();
            });
            this.props.loadUserCatalog("beforeWidget")
        }
        else if( result.status===10 )
        {
            Cache.logout(this.props);
        }
        else if( result.status===-1 )
        {
            let messageOptions = this.state.messageOptions;
            messageOptions["isMessage"] = true ;
            messageOptions["message"] = result.message;
            messageOptions["title"] = "添加超过上限" ;
            this.state['messageOptions'] = messageOptions;
            this.messageRef.open();
        }   
    }

    pageTurning(pageIndex)
    {
        
    }

    messageRef = (ref) => {
        this.messageRef = ref;
    }

    businessCatalogEntity(item)
    {
        this.props.businessCatalogEntity(item,this.state.catlogs)
    }

    render() {

        let { catlogData, messageOptions, isLoading } = this.state;

        return (
                <div className="itemsContent">
                    {
                        isLoading?<img src={LoadingTag} className='loadingTags-style'/>:
                        catlogData.map((item,ind)=>{
                            let startSvg = item.PRIVILEGE === 2? "unfollow.svg":"addTheAttention.svg"
                            return (
                                <div className="itemsStyle" key={ind} >
                                    <div className="starIcon" 
                                            onClick={()=>{this.removeFavor( item.PRIVILEGE === 1 ? true : false, item.CTGCODE, item.NAME)}}
                                    >
                                        <WidgetTips icon={startSvg} tipContent={item.PRIVILEGE=== 1 ? "添加关注" : "取消关注"}/>
                                    </div>
                                    
                                    <p className="font-16 font-PingFangSCMedium fontWeight-600 clear-margin paddingTop-10">{item.NAME}</p>

                                    <p className="font-14 font-PingFangFCRegular color-323232 clear-margin paddingTop-10">{item.REMARK}</p>

                                    <p className="font-14 color-323232 font-PingFangFCRegular clear-margin paddingTop-10 color-323232">
                                        企业数量：
                                        <span className="font-14 color-EE6364">{item.ENTITIES}</span>
                                    </p>

                                    <p className="font-14 clear-margin font-PingFangFCRegular paddingTop-10 cursor-pointer color-016EFF"
                                        onClick={()=>{this.businessCatalogEntity(item)}}>{"立即查看 >"}</p>
                                </div>
                            )
                        })
                    }
                    <WidgetMessage options={messageOptions} onRef={this.messageRef} />
                    {
                        catlogData.length === 0 ?
                        null :
                        <div className='BusinessChanceWidgetPageBox' style={{width:"100%",paddingRight:"31px"}}>
                            <WidgetPage pageTurning = {this.pageTurning} total={catlogData.length}></WidgetPage>  
                        </div>
                    }
                </div>
                
        )
    }
}

export default BusinessCatlogs;